import {connect} from "react-redux";
import Card from "../../../Components/Card/Card";
import routes from "../../../Constants/routes";
import {useNavigate} from "react-router-dom";
import {bindActionCreators} from "redux";
import TargetGroupActions from "../../../Actions/Voss/targetGroupActions";
import {TargetGroupsTable} from "../../../Components/Voss/TargetGroups/TargetGroupsTable";
import {useEffect} from "react";
import { useTranslation} from "react-i18next";

function TargetGroupsContainer ({ targetGroupsActions, targetGroups, }){
    const navigate = useNavigate();
    const {t} = useTranslation();

    useEffect(() => {
        if (!targetGroups)
            targetGroupsActions.getTargetGroups();
    }, []);

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t('common.targetgroup')}</Card.Header.Title>
            </Card.Header>
            <Card.Content>

                <div className="mb-12">
                    <button className="btn btn-primary"
                            onClick={() => navigate(routes.vossTargetGroupsCreate)}>{t('targetgroupeditcontainer.createtargetgroup')}
                    </button>
                </div>
                <div>
                    <TargetGroupsTable targetGroups={targetGroups}/>
                </div>
            </Card.Content>
        </Card>
    );
}



function mapDispatchToProps(dispatch) {
    return {
        targetGroupsActions: bindActionCreators(TargetGroupActions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        targetGroups: state.TargetGroupsReducer.targetGroups
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TargetGroupsContainer);
